var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F79E1E;}\r\n\t.st1{fill:#E46025;}\r\n\t.st2{fill:#B65B27;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.3,339.6 190,246.7 74.9,339.6 214.5,259.4 212.3,275.5 235.6,262.6 288.1,312.3 316.1,228.2  351.6,223.2 336,174.6 369,145.9 325.2,127.4 337.2,76.4 296.9,94.9 277.9,49.3 243.8,83.3 187.7,53.9 177.6,109.1 125.8,120.3  156.5,138.9 125.6,154.4 151.8,156.6 44,240.5 152.5,182.8 36,271.4 159.9,206.9 27.7,306.4 173.5,228.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.8,175.4c-1.9,46.6-41.3,82.8-87.9,80.9c-46.6-1.9-82.8-41.3-80.9-87.9s41.3-82.8,87.9-80.9 C296.5,89.4,332.7,128.7,330.8,175.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.7,244.7c-46.6-1.9-82.8-41.3-80.9-87.9c0.9-21.6,9.8-40.9,23.8-55.2c-21.7,14.5-36.4,38.8-37.6,66.8 c-1.9,46.6,34.3,86,80.9,87.9c25,1,48-8.9,64.2-25.7C292.7,240.2,275.3,245.5,256.7,244.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.9,172.8c0-3-0.1-6-0.4-9c-4.9-3.4-10.6-6-17.6-6.9c-1.3-0.2-2.5-0.3-3.8-0.4c-0.8-5.6-2.1-11-3.7-16.4 c0.9,0.1,1.7,0.1,2.6,0.2c5.9,0.5,11.8,1.1,17.6,1.9c-0.8-2.2-1.7-4.3-2.6-6.3c-6.5-1-13.1-1.7-19.8-2.3h-0.1 c-2.2-5.5-4.7-10.6-7.8-15.7c4.3-0.9,8.2-2.6,11.3-5.6c-1.5-1.6-3.3-3.2-5-4.6c-2.7,2.5-6.2,3.8-10.3,4.4c-0.6-0.9-1.3-1.7-1.9-2.5 c-5.7-7.5-12.4-13.8-19.7-19c-6.4-1.8-13-2.9-19.9-3.3c-0.4,0-0.7,0-1.2,0c12.8,5.1,24.3,13.6,33.5,24.9 c-8.8-0.8-18.9-3.8-28.9-6.7c-3-0.9-5.9-1.7-8.6-2.5c-17.1-4.7-30.2-5.5-40-4.6c-7.3,4.2-13.9,9.4-19.7,15.5 c10.6-4.5,32.1-12,58.2-4.8c2.7,0.7,5.6,1.6,8.6,2.5c11.5,3.4,24.4,7.2,35.6,7.3c3.1,4.6,5.7,9.4,7.9,14.5 c-2.2-0.1-4.4-0.2-6.6-0.2c-54.2-0.9-100.8,15.3-126.6,41.2c0.2,5.2,0.7,10.2,1.7,15.1c7.3-10.5,18-19.9,31.9-27.8 c26.3-14.7,61.1-22.6,98.1-21.8c1.3,0,2.5,0.1,3.8,0.1c1.9,5.4,3.3,10.9,4.2,16.6c-23.8,1-39.3,15.9-57.1,31.8 c-15.9,14.3-35.4,28.5-63.8,37c2.6,3.3,5.6,6.4,8.7,9.2c26.9-10.7,44.6-27.6,59.6-41.1c17.1-15.3,31.8-29.9,53.2-30.7 c0.5,5.9,0.5,12,0,18.1c-2.9,33.1-22,61.2-48.2,75c6.6-0.6,13.2-2,19.3-4.2c2.1-1.7,4.2-3.5,6.1-5.5c17.1-16.8,27.8-39.9,29.9-64.7 c0.5-6.2,0.5-12.4,0-18.5c1.1,0.1,2.2,0.2,3.3,0.4C320.5,164.6,326.3,168.4,330.9,172.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhx);
export default __webpack_public_path__ + "static/media/PHX.01d78c628f1c0bf0dc63f5854482afc2.svg";
export { ForwardRef as ReactComponent };